import React, { useCallback, useMemo, useState } from "react";
import { DatePicker, Form, Input, Select } from "antd";
import CustomButton from "components/Common/buttons/CustomButton";
import useStoreFilters from "customHooks/useStoreFilters";
import { FILTER_PAGE } from "utils/constants";
import { dateFormat } from "pages/TAM/TAMRequests/constants";
import { makeStyles } from "@material-ui/core/styles";
import NGISelect from "components/Common/inputs/NGISelect";
import { useSelector } from "react-redux";
import { FirmwaresSettingsSelector } from "store/meter-management/configuration/firmware/selectors";
import { filterOptions } from "pages/meter-management/firmware/metersFirmwareUpdateHistory/variables";
import { preparedFilterData } from "pages/meter-management/firmware/metersFirmwareUpdateHistory/utils";
import { inputPatternTitle, inputTextPattern } from "components/Common/inputs/variables";

const { Option } = Select;
const { RangePicker } = DatePicker;

const useStyles = makeStyles({
  root: { width: "250px!important" },
});

const ALLOWED_STATUSES = ["Published", "Draft"];

const MetersFirmwareUpdateHistoryFilter = ({ handleFilter }) => {
  const classes = useStyles();
  const [form] = Form.useForm();
  const { getFilters } = useStoreFilters(FILTER_PAGE.METERS_FIRMWARE_HISTORY);
  const [activeFilter, setActiveFilter] = useState(null);
  const { firmwares } = useSelector(FirmwaresSettingsSelector);

  const onSearch = useCallback(values => {
    const { pageSize } = getFilters();
    const preparedData = preparedFilterData(values, values.type);
    handleFilter({ ...preparedData, pageSize });
  }, []);

  const handleFilterChange = useCallback(
    item => {
      setActiveFilter(item);
      form.setFieldsValue({ new: null, old: null });
    },
    [form]
  );

  const newFilteredFirmwares = useMemo(() => firmwares.filter(item => ALLOWED_STATUSES.includes(item.status)), []);

  return (
    <div className="custom-filter">
      <Form form={form} name="horizontal_login" layout="inline" onFinish={onSearch}>
        <Form.Item name="type">
          <Select showSearch onChange={handleFilterChange} placeholder={"Select type"} allowClear>
            {filterOptions.map(item => (
              <Option key={item.value} value={item.value}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        {(activeFilter === "both" || activeFilter === "old") && (
          <>
            <div className="filter-divider" />
            <Form.Item rules={[{ required: true, message: "Please select value" }]} name="old">
              <NGISelect showSearch className={classes.root} placeholder="Please select old firmware">
                {!!firmwares &&
                  firmwares.map(item => (
                    <Option value={item.version} key={item.version}>
                      {item.version}
                    </Option>
                  ))}
              </NGISelect>
            </Form.Item>
            <div className="filter-divider" />
          </>
        )}

        {(activeFilter === "both" || activeFilter === "new") && (
          <>
            <div className="filter-divider" />
            <Form.Item rules={[{ required: true, message: "Please select value" }]} name="new">
              <NGISelect showSearch className={classes.root} placeholder="Please select new firmware">
                {!!newFilteredFirmwares &&
                  newFilteredFirmwares.map(item => (
                    <Option value={item.version} key={item.version}>
                      {item.version}
                    </Option>
                  ))}
              </NGISelect>
            </Form.Item>
            <div className="filter-divider" />
          </>
        )}

        {activeFilter === "barcode" && (
          <>
            <div className="filter-divider" />
            <Form.Item rules={[{ required: true, message: "Please select value" }]} name="barcode">
              <Input placeholder={"Enter value"} allowClear pattern={inputTextPattern} title={inputPatternTitle} />
            </Form.Item>
            <div className="filter-divider" />
          </>
        )}

        {activeFilter === "id" && (
          <>
            <div className="filter-divider" />
            <Form.Item rules={[{ required: true, message: "Please select value" }]} name="id">
              <Input placeholder={"Enter value"} allowClear pattern={inputTextPattern} title={inputPatternTitle} />
            </Form.Item>
          </>
        )}

        {activeFilter !== "id" && (
          <Form.Item name="date" className={classes.root}>
            <RangePicker inputReadOnly={true} format={dateFormat} size={"default"} />
          </Form.Item>
        )}

        <CustomButton size="small" type="primary" htmlType="submit" text="Search" />
      </Form>
    </div>
  );
};

export default MetersFirmwareUpdateHistoryFilter;
